var ZFComponentName = "ZFComponent";
var _ZFComponent = null;

var Initialize = function()
{
	try
	{
		_ZFComponent = document.getElementById(ZFComponentName);
		console.log("Hi ZFComponent ");
		
		var Ret = _ZFComponent.Initialize();
		
		console.log("Ret== "+Ret);
		

		if(Ret.startsWith("-") || Ret != "")
		{
			ProcessError(Ret);
			return false;
		}
		
		
		return true;
	}
	catch(e)
	{
		alert("Webcomponent Initialization Failed, Details: "+e);
		return false;
	}
}


function Disconnect() 
{
	try
	{
		_ZFComponent = document.getElementById(ZFComponentName);
		
		var Ret = _ZFComponent.Disconnect();

		if(Ret.startsWith("-") || Ret != "")
		{
			ProcessError(Ret);
			return false;
		}
		
		return true;
	}
	catch(e)
	{
		alert("Disconnect Failed, Details: "+e);
		return false;
	}
}

function ReadPublicData(readPhotography, readNonModifiableData,
		readModifiableData, readSingatureImage, readAddress, readRootCertificate)
{
	try {
		if(_ZFComponent == null)
		{
			alert("The Webcomponent is not initialized.");
			return false;
		}
		
		var Ret = _ZFComponent.ReadPublicData(readPhotography, readNonModifiableData,
				readModifiableData, readSingatureImage, readAddress, readRootCertificate);

		if(Ret.startsWith("-") || Ret != "")
		{
			ProcessError(Ret);
			return false;
		}
		
		return true;
	} catch(e) {
		alert("Read public data failed, Details: " + e);
	}
	
}


function GetEF_IDN_CN(){return _ZFComponent.GetEF_IDN_CN();}

function GetEF_HolderSignatureImage(){return _ZFComponent.GetEF_HolderSignatureImage();}

function GetEF_Photography(){return _ZFComponent.GetEF_Photography();}

function GetEF_ModifiableData(){return _ZFComponent.GetEF_ModifiableData();}

function GetEF_NonModifiableData(){return _ZFComponent.GetEF_NonModifiableData();}

function GetEF_RootCertificate(){return _ZFComponent.GetEF_RootCertificate();}

function GetEF_HomeAddressData(){return _ZFComponent.GetEF_HomeAddressData();}

function GetEF_WorkAddressData(){return _ZFComponent.GetEF_WorkAddressData();}

function GetCardVersion(){return _ZFComponent.GetCardVersion();}

function GetCardSerialNumber(){return _ZFComponent.GetCardSerialNumber();}
function GetChipSerialNumber(){return _ZFComponent.GetChipSerialNumber();}
function GetIssuerSerialNumber(){return _ZFComponent.GetIssuerSerialNumber();}
function GetIssuerReferenceNumber(){return _ZFComponent.GetIssuerReferenceNumber();}
function GetCPLC0101(){return _ZFComponent.GetCPLC0101();}
function GetCPLC9F7F(){return _ZFComponent.GetCPLC9F7F();}


window.Initialize = Initialize;
window.Disconnect = Disconnect;
window.GetCPLC9F7F = GetCPLC9F7F;
window.GetCPLC0101 = GetCPLC0101;
window.GetIssuerReferenceNumber = GetIssuerReferenceNumber;
window.GetIssuerSerialNumber = GetIssuerSerialNumber;
window.GetChipSerialNumber = GetChipSerialNumber;
window.GetCardSerialNumber = GetCardSerialNumber;
window.GetCardVersion = GetCardVersion;
window.GetEF_WorkAddressData = GetEF_WorkAddressData;
window.GetEF_HomeAddressData = GetEF_HomeAddressData;
window.GetEF_RootCertificate = GetEF_RootCertificate;
window.GetEF_NonModifiableData = GetEF_NonModifiableData;
window.GetEF_ModifiableData = GetEF_ModifiableData;
window.GetEF_Photography = GetEF_Photography;
window.GetEF_HolderSignatureImage = GetEF_HolderSignatureImage;
window.GetEF_IDN_CN = GetEF_IDN_CN;
window.ReadPublicData = ReadPublicData;
window.Disconnect = Disconnect;


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/zfcomponent.js
// module id = 322
// module chunks = 2